<template>
  <div class="hero-static">
    <div class="content signin-footer">
      <div class="row justify-content-center">
        <div class="col-md-8 col-lg-6 col-xl-4">
          <div class="block block-themed block-fx-shadow mb-0">
            <div class="block-header">
              <h3 class="block-title">Sign In</h3>
              <div class="block-options">
                <router-link to="/forgot" class="btn-block-option font-size-sm" title="Forgot Password">
                  Forgot Password?
                </router-link>
                <router-link to="/signup" class="btn-block-option" title="Create New Account">
                  <i class="fa fa-user-plus"></i>
                </router-link>
              </div>
            </div>
            <div class="block-content">
              <div class="signin-content">
                <h1 class="mb-2">GrowTracker</h1>
                <alert-message></alert-message>
                <form name="login" method="POST" v-on:submit.prevent>
                  <div class="py-3">
                    <div class="form-group">
                      <input type="text" class="form-control form-control-alt form-control-lg" id="username" v-model="email" name="username" placeholder="Username (use email)" v-validate="'required|email'" data-vv-as="Email">
                      <p v-if="errors.has('username')" class="errorMsg">{{ errors.first('username') }}</p>
                    </div>
                    <div class="form-group login-password">
                      <input :type="passwordType" class="form-control form-control-alt form-control-lg" id="login-password" v-model="password" name="userPassword" placeholder="Password" v-validate="'required'" data-vv-as="Password">
                      <span class="password-eye-icon" @click=showPassword() :class="pwdIcon"></span>
                      <p v-if="errors.has('userPassword')" class="errorMsg">{{ errors.first('userPassword') }}</p>
                    </div>
                    <div class="form-group">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="login-remember" v-model="rememberme" name="login-remember" value="1"/>
                        <label class="custom-control-label font-w400" for="login-remember">Remember Me</label>
                      </div>
                    </div>
                    <div class="form-group" v-show="showCaptcha">
                      <vue-recaptcha class="google-recaptcha" @verify="onVerify" sitekey="6LeI2p0UAAAAAOd1k7LSkZ0LT-HCxK-UB9V8O5-f"></vue-recaptcha>
                      <p v-if="captchaErr" class="errorMsg"> {{ captchaErr }}</p>
                    </div>
                  </div>
                  <div class="signin-button row button-loader">
                    <div class="col-md-12 col-xl-12">
                      <button type="submit" class="btn btn-block btn-primary" @click="signIn()" v-bind:disabled="showLoader">
                        <div><i class="fa fa-fw fa-sign-in-alt mr-1"></i><span>Sign In</span></div>
                        <span class="modal-loader" v-if="showLoader">
                          <hash-loader class="custom-class text-dark" color="#fff" loading="loading" size="20" sizeUnit="px"></hash-loader>
                        </span>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapActions } from 'vuex';
import VeeValidate from 'vee-validate';
import { VueSpinners } from '@saeris/vue-spinners';
import { HashLoader } from '@saeris/vue-spinners';
import Footer from '@/components/Footer';
import AlertMessage from '@/components/AlertMessage';
import VueRecaptcha from 'vue-recaptcha';
import { helper } from '@/helper.js';
import base64 from 'base-64';
import utf8 from 'utf8';
Vue.use(VueSpinners);
Vue.use(VeeValidate);
Vue.use(base64, utf8);

VeeValidate.Validator.extend('email', {
  getMessage: field => 'Please enter a valid email.',
  validate: value => {
    return /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value);
  }
});
  
export default {
  name: 'Signin',
  data: () => ({
    email: '',
    password: '',
    passwordType: 'password',
    pwdIcon: 'fa fa-eye',
    rememberme: 0,
    errMsg: '',
    captchaStatus: false,
    captchaErr: '',
    showCaptcha: false,
    showLoader: false
  }),
  components: { Footer, AlertMessage, VueRecaptcha, HashLoader },
  mounted() {
    let vm = this;
    helper.sendRequest('/login/getlastauthstatus').then((data) => {
      if ((typeof data !== 'undefined') && data.showCaptcha === 1) {
        vm.showCaptcha = true;
      }
    });
    vm.handleAlertMessage();
  },
  methods: {
    ...mapActions('alert', ['success', 'error', 'clear']),
    signIn() {
      if (this.showCaptcha && !this.captchaStatus) {
        this.captchaErr = 'Please complete re-captcha.';
        return;
      }
      let vm = this;
      this.$validator.validate().then(valid => {
        if (valid) {
          this.showLoader = true;
          helper.sendPostRequest('/login', {
            'USERNAME' : vm.email,
            'PASSWORD' : base64.encode(utf8.encode(vm.password)),
            'remember_me' : vm.rememberme,
            'captcha_status': vm.captchaStatus
          }).then((data) => {
            if (data.status === 'success') {
              if (typeof data.data.email !== 'undefined') {
                localStorage.token = base64.encode(utf8.encode(data.data.email));
              }
              vm.$router.push('/');
            } else {
              if (
                (typeof data.data !== 'undefined') &&
                data.data.showCaptcha === 1
              ) {
                vm.showCaptcha = true;
              } else {
                vm.showCaptcha = true;
                vm.error(data.message);
                vm.handleAlertMessage();
              }
            }
            vm.showLoader = false;
          });
        }
      });
    },
    showPassword() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
      this.pwdIcon = this.pwdIcon === 'fa fa-eye' ? 'fa fa-eye-slash' : 'fa fa-eye';
    },
    onVerify: function() {
      if (grecaptcha && grecaptcha.getResponse().length > 0) {
        this.captchaStatus = true;
        this.captchaErr = '';
      }
    },
    handleAlertMessage() {
      let vm = this;
      setTimeout(() => { vm.clear(); }, 5000);
    }
  },
  beforeDestroy() {
    this.clear();
  }
};
</script>

<style>
.signin-content {
  padding: 1rem;
}
.login-password {
  position: relative;
}
.login-password .password-eye-icon {
  position: absolute;
  top: 16px;
  right: 12px;
}
.signin-button {
  margin-bottom: 1rem;
}
.errorMsg {
  color: red;
  font-size: 0.7rem;
  margin-bottom: 0 !important;
  line-height: 16px;
  padding-top: 5px;
}
.signin-footer {
  min-height: calc(100vh - 61px);
  padding-bottom: 2rem;
}
.alert {
  margin-bottom: 3px !important;
}
.custom-class {
  margin: 0 auto;
}
.loader {
  padding-top: 10px;
}
.button-loader button {
  display: inline-flex;
  display: -ms-flexbox;
  -ms-flex-pack: center;
  -ms-flex-align: center;
  -ms-align-items: flex-start;
  display: -webkit-inline-flex;
  -webkit-justify-content: center;
  justify-content: center;
}
@media only screen and (max-width: 767px) {
  .google-recaptcha iframe {
    transform: scale(0.7);
    -webkit-transform: scale(0.7);
    transform-origin: 0 0;
    -webkit-transform-origin: 0 0;
    width: 305px;
    display: block;
  }
  .google-recaptcha div:first-child {
    width: auto !important;
    height: 54px !important;
  }
}
</style>



// WEBPACK FOOTER //
// source/components/Signin.vue